const configured = import.meta.env.VITE_NUVEMSHOP_API_URL?.replace(/\/$/, '');
const base = import.meta.env.DEV ? '/local-affiliates' : configured;
const referralKey = 'rica-tanto-referral';
const referralCodeKey = 'rica-tanto-referral-code';
const REFERRAL_CODE_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
let pending: Promise<void> | undefined;

export async function affiliateRequest(body: Record<string, unknown>) {
  if (!base) throw new Error('O programa de afiliados ainda não está disponível.');
  const response = await fetch(`${base}/affiliates.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok || !data) throw new Error(data?.message || 'Não foi possível acessar o programa. Tente novamente mais tarde.');
  return data;
}

export function captureReferral(code: string): Promise<void> {
  // Run serially so a slower response cannot overwrite a more recent link.
  pending = (pending || Promise.resolve()).then(async () => {
    if (!/^[a-z0-9-]{3,40}$/.test(code)) return;
    // Guarda o código antes de pedir a indicação: se o servidor estiver fora do ar
    // nesse instante, a compra ainda consegue ser atribuída na hora do checkout.
    try { localStorage.setItem(referralCodeKey, JSON.stringify({ code, at: Date.now() })); } catch { /* Storage may be blocked. */ }
    const data = await affiliateRequest({ action: 'capture', code });
    if (data.referral) {
      try { localStorage.setItem(referralKey, JSON.stringify(data.referral)); } catch { /* Storage may be blocked. */ }
    }
  }).catch(() => { /* An unavailable program must not break storefront navigation. */ });
  return pending;
}

export async function getReferralToken(): Promise<string | undefined> {
  await pending;
  try {
    const ref = JSON.parse(localStorage.getItem(referralKey) || 'null');
    if (typeof ref?.token === 'string' && ref.expires * 1000 > Date.now()) return ref.token;
    localStorage.removeItem(referralKey);
  } catch { /* Server validates every token, including expiry. */ }
  return recoverReferralToken();
}

// A indicação não foi gravada (servidor fora do ar ou limite de acessos na hora do
// clique), mas o visitante chegou por um link de afiliado nos últimos 30 dias:
// tenta de novo agora, no checkout, em vez de perder a comissão.
async function recoverReferralToken(): Promise<string | undefined> {
  try {
    const stored = JSON.parse(localStorage.getItem(referralCodeKey) || 'null');
    if (typeof stored?.code !== 'string' || typeof stored?.at !== 'number' || Date.now() - stored.at > REFERRAL_CODE_MAX_AGE_MS) {
      localStorage.removeItem(referralCodeKey);
      return undefined;
    }
    const data = await affiliateRequest({ action: 'capture', code: stored.code });
    if (data.referral?.token) {
      localStorage.setItem(referralKey, JSON.stringify(data.referral));
      return data.referral.token as string;
    }
  } catch { /* Sem indicação: a compra segue normalmente. */ }
  return undefined;
}
